import dayjs from 'dayjs';
import React, { useState } from 'react';
import { DayPickerProps } from 'react-day-picker';

import { DatePicker } from '@/components/common/DatePicker';
import { IHeaderSearchFilterDates } from '@/redux/modules/globalHeader';

import { INavbarSearch } from '../../../SearchHeader';
import DateContentFooter from './DateContentFooter';

interface IDateContentProps {
  className?: string;
  open?: boolean;
  dates?: IHeaderSearchFilterDates;
  onChangeDates: INavbarSearch['onChangeDates'];
  disabledDays?: DayPickerProps['disabled'];
  allowClear?: boolean;
  maximumDays?: number;
}

const DateContent: React.FC<IDateContentProps> = ({
  className = '',
  open,
  dates,
  onChangeDates,
  disabledDays = [],
  allowClear = true,
  maximumDays,
}) => {
  const [datesValue, setDatesValue] = useState<IHeaderSearchFilterDates | undefined>(dates);

  const handleChangeDates = (newDates: IHeaderSearchFilterDates) => {
    setDatesValue({ ...datesValue, ...newDates });
    onChangeDates({ ...datesValue, ...newDates });
  };

  const handleClearDates = () => {
    setDatesValue({});
    onChangeDates({});
  };

  // `hidden` as well as the class: the panels that are off screen stay mounted so
  // they keep their in-progress state (this one holds a half-picked range), and only
  // the attribute takes them out of the accessible tree and the dropdown's tab order.
  return (
    <div hidden={!open} className={`p-4 pb-2 ${open ? 'block' : 'hidden'}`}>
      <DatePicker
        className={className}
        range
        numberOfMonths={2}
        isStacked={false}
        onChange={handleChangeDates}
        disabledDays={disabledDays}
        dateTo={datesValue?.to}
        dateFrom={datesValue?.from}
        fromMonth={dayjs().toDate()}
        toMonth={dayjs().add(2, 'year').toDate()}
        size="small"
        maximumDays={maximumDays}
      />
      <DateContentFooter
        datesValue={datesValue}
        handleChangeDates={handleChangeDates}
        handleClearDates={handleClearDates}
        allowClear={allowClear}
      />
    </div>
  );
};

export default DateContent;
